// import React, { useContext } from "react";
// import { useState, useEffect } from "react";
// import "./MatchmakerProfileEdit.css";
// import profileImg from "../../assets/images/placeholder-image.jpg";
// import { CgProfile } from "react-icons/cg";
// import cameraImg from "../../assets/images/camera.png";
// import { Link, useNavigate } from "react-router-dom";
// import { useFormik } from "formik";
// import { ToastContainer, toast } from "react-toastify";
// import { object, string } from "yup";

// import { axiosInstance } from "../../axiosInstance";
// import translations from "./translation.json";
// import { LanguageContext } from "../../Components/LanguageContext";
// import Select from "react-select";
// import * as Yup from "yup";

// const options = [
//   { value: "Match Maker", label: "Match Maker" },
//   { value: "Photographer", label: "Photographer", isDisabled: true },
//   { value: "Beautician", label: "Beautician", isDisabled: true },
//   {
//     value: "Event Hall Manager",
//     label: "Event Hall Manager",
//     isDisabled: true,
//   },
// ];
// // const SUPPORTED_FORMATS = [
// //   "image/jpeg",
// //   "image/png",
// //   "image/jpg",
// //   "image/webp",
// // ];
// // const ValidateSchema = Yup.object().shape({
// //   profile_pic: Yup.mixed()
// //     .nullable()  // allow empty (not required)
// //     .test(
// //       "fileFormat",
// //       "Only PNG, JPG, JPEG, or WEBP images are allowed",
// //       (value) => {
// //         if (!value) return true; // allow empty (not required)
// //         return SUPPORTED_FORMATS.includes(value.type); // check type if file exists
// //       }
// //     ),
// // });

// export function MatchmakerProfileEdit() {
//   const { language } = useContext(LanguageContext);
//   // const [imageNames, setImageNames] = useState("Browse");
//   const [profileImgPreview, setProfileImgPreview] = useState(profileImg); // initial value
//   const [selectedProfileFile, setSelectedProfileFile] = useState(null);
//   const [documentname, setDocumentName] = useState();
//   const [selectedDocumentFile, setSelectedDocumentFile] = useState(null);
//   const [aadharImgPreview, setAadharImgPreview] = useState();
//   const [formfields, setformFields] = useState(true);
//   const [activeTab, setActiveTab] = useState("basicdetails");

//   function handleBasicDetails() {
//     setformFields(true);
//   }
//   function handleMoreDetails() {
//     setformFields(false);
//   }
//   const formik = useFormik({
//     initialValues: {
//       profile_pic: "",
//       mobile: "",
//       email: "",
//       category: [],
//       full_name: "",
//       first_name: "",
//       last_name: "",
//       agency_name: "",
//       document: "",
//       about: "",
//       terms_condition: "",
//     },
//     // validationSchema:ValidateSchema,
//     onSubmit: async (values) => {
//       try {
//         const formData = new FormData();

//         // Append text fields
//         formData.append("first_name", values.first_name);
//         formData.append("last_name", values.last_name);
//         formData.append("email", values.email);
//         formData.append("mobile", values.mobile);
//         formData.append("agency_name", values.agency_name);
//         formData.append("document", values.document);
//         formData.append("about", values.about);
//         formData.append("terms_condition", values.terms_condition);
//         formData.append("category", values.category);

//         // Append file only if selected
//         if (selectedProfileFile) {
//           formData.append("profile_pic", selectedProfileFile);
//         }
//         if (selectedDocumentFile) {
//           formData.append("document", selectedDocumentFile);
//         }
//         const response = await axiosInstance.put("/profile", formData, {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         });

//         if (response.data.status === true) {
//           toast.success(response.data.message || "Updated Successfully!");
//           LoadProfile();
//         } else {
//           toast.error("Something went wrong, please try again!");
//         }
//       } catch (error) {
//         console.error("Submission failed:", error);
//         toast.error("Submission failed! Please try again.");
//       }
//     },
//   });
//   async function LoadProfile() {
//     try {
//       const response = await axiosInstance.get("/profile");
//       const { data } = response.data;
//       if (data) {
//         const {
//           profile_pic = "",
//           mobile = "",
//           first_name = "",
//           last_name = "",
//           email = "",
//           category = [],
//           agency_name = "",
//           document = "",
//           about = "",
//           terms_condition = "",
//         } = data;

//         formik.setValues({
//           profile_pic,
//           mobile,
//           first_name,
//           last_name,
//           email,
//           category: category[0] || "",
//           agency_name,
//           document,
//           about,
//           terms_condition,
//         });

//         if (profile_pic) {
//           setProfileImgPreview(profile_pic);
//         } else {
//           setProfileImgPreview(profileImg);
//         }

//         if (document) {
//           setDocumentName("Browse");
//           setAadharImgPreview(document);
//         } else {
//           setDocumentName("Browse");
//           setAadharImgPreview(null);
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching user details", error);
//     }
//   }

//   useEffect(() => {
//     LoadProfile();
//   }, []);
//   return (
//     <>
//       <ToastContainer />
//       <div className="matchmakerEditBg">
//         <div className="container">
//           <div className="profileImgContainer">
//             <div className="matchmakerProfileImg">
//               <img src={profileImgPreview} alt="Profile Preview" />
//             </div>
//             <div className="cameraImgContainer">
//               <label for="cameraImg">
//                 <img src={cameraImg} />
//               </label>

//               <input
//                 type="file"
//                 id="cameraImg"
//                   accept="image/*"
//                 style={{ display: "none" }}
//                 onChange={(e) => {
//                   const file = e.target.files[0];
//                   if (file) {
//                     const imageUrl = URL.createObjectURL(file);
//                     setProfileImgPreview(imageUrl);
//                     setSelectedProfileFile(file); // Save file for upload
//                   }
//                 }}
//               />

//             </div>
//           </div>
//           <div>
//                   {formik.touched.profile_pic && formik.errors.profile_pic && (
//                     <div className="text-danger text-center">{formik.errors.profile_pic}</div>
//                   )}
//                 </div>
//           <div className="profile-tabs">
//             <div>
//               <button
//                 onClick={() => {
//                   handleBasicDetails();
//                   setActiveTab("basicdetails");
//                 }}
//                 className={
//                   activeTab === "basicdetails" ? "active-profiletab" : ""
//                 }
//               >
//                 {translations[language].basic_details}
//               </button>
//             </div>
//             <div>
//               <button
//                 onClick={() => {
//                   handleMoreDetails();
//                   setActiveTab("moredetails");
//                 }}
//                 className={
//                   activeTab === "moredetails" ? "active-profiletab" : ""
//                 }
//               >
//                 {translations[language].more_details}
//               </button>
//             </div>
//           </div>
//           <form onSubmit={formik.handleSubmit}>
//             {formfields ? (
//               <div className="detailsContainer">
//                 {/* row1 */}
//                 <div className="detailsGrid">
//                   <div>
//                     <div>
//                       <label for="first_name">
//                         {translations[language].first_name}
//                       </label>
//                     </div>
//                     <input
//                       type="text"
//                       onChange={formik.handleChange}
//                       value={formik.values.first_name}
//                       id="first_name"
//                     />
//                   </div>
//                   <div>
//                     <div>
//                       <label for="last_name">
//                         {translations[language].last_name}
//                       </label>
//                     </div>
//                     <input
//                       type="text"
//                       onChange={formik.handleChange}
//                       value={formik.values.last_name}
//                       id="last_name"
//                     />
//                   </div>
//                 </div>
//                 {/* row2 */}
//                 <div className="detailsGrid">
//                   <div>
//                     <div>
//                       <label for="email">{translations[language].email}</label>
//                     </div>
//                     <input
//                       type="email"
//                       onChange={formik.handleChange}
//                       value={formik.values.email}
//                       id="email"
//                     />
//                   </div>
//                   <div>
//                     <div>
//                       <label for="mobile">
//                         {translations[language].mobile}
//                       </label>
//                     </div>
//                     <input
//                       type="text"
//                       onChange={formik.handleChange}
//                       id="mobile"
//                       value={formik.values.mobile}
//                       disabled
//                     />
//                   </div>
//                 </div>
//                 {/* row3 */}
//                 <div className="detailsGrid">
//                   <div>
//                     <div>
//                       <label>{translations[language].profession}</label>
//                     </div>
//                     {/* <input
//                   type="text"
//                   onChange={formik.handleChange}
//                   disabled
//                   value={formik.values.category?formik.values.category:"Match Maker"}
//                 /> */}
//                     <Select
//                       placeholder="Select"
//                       options={options}
//                       isSearchable={false}
//                       value={options.find(
//                         (option) => option.value === formik.values.category
//                       )} //for formik
//                       onChange={(selectedOption) =>
//                         formik.setFieldValue("category", selectedOption.value)
//                       } //for formik
//                       styles={{
//                         control: (base, state) => ({
//                           ...base,
//                           width: "100%",
//                           minHeight: "40px",
//                           height: "40px",
//                           fontSize:"16px",
//                           display: "flex",
//                           alignItems: "center",
//                           borderColor: "#e4e4e4",
//                           backgroundColor: "#ffffff",
//                           borderRadius: "10px",
//                           // marginBottom: "10px",
//                           borderColor: state.isFocused
//                             ? "#e4e4e4"
//                             : base.borderColor,
//                           boxShadow: state.isFocused
//                             ? "#e4e4e4"
//                             : base.boxShadow,
//                           "&:hover": {
//                             borderColor: "#e4e4e4",
//                           },
//                         }),
//                         indicatorSeparator: () => ({
//                           display: "none",
//                         }),
//                         option: (base, state) => ({
//                           ...base,
//                           backgroundColor: state.isFocused
//                             ? "#FEECF0"
//                             : state.isSelected
//                             ? "transparent"
//                             : "transparent",
//                           color: "#707070",
//                           cursor: "pointer",
//                           ":active": {
//                             backgroundColor: "#FEECF0", // fixes the blue flicker when selecting
//                           },
//                         }),

//                         menu: (base) => ({
//                           ...base,
//                           width: "100%",
//                         }),
//                         singleValue: (base) => ({
//                           ...base,
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                         }),
//                       }}
//                     />
//                   </div>
//                   <div>
//                     <div>
//                       <label for="agency_name">
//                         {translations[language].agency_name}
//                       </label>
//                     </div>
//                     <input
//                       type="text"
//                       onChange={formik.handleChange}
//                       value={formik.values.agency_name}
//                       id="agency_name"
//                     />
//                   </div>
//                 </div>
//                 {/* row4 */}
//                 <div className="detailsGrid">
//                   <div>
//                     <label>{translations[language].aadhaar_pan}</label>

//                     {/* <label for="document" className="custom-file-label">
//                   {documentname}
//                 </label>

//                 <input
//                   type="file"
//                   id="document"
//                   className="custom-file-input"
//                   style={{ display: "none" }}
//                   onChange={(e) => {
//                     const file = e.target.files[0];
//                     if (file) {
//                       setSelectedDocumentFile(file);
//                       setDocumentName(file); // set file object to access .name
//                     }
//                   }}
//                 /> */}
//                     <label for="document" className="custom-file-labelEdit">
//                       {documentname}
//                     </label>

//                     <input
//                       type="file"
//                       id="document"
//                       className="custom-file-input"
//                       style={{ display: "none" }}
//                       // onChange={(e) => {
//                       //   const file = e.target.files[0];
//                       //   if (file) {
//                       //     setSelectedDocumentFile(file);
//                       //     setDocumentName(file); // set file object to access .name
//                       //   }
//                       // }}
//                       onChange={(e) => {
//                         const file = e.target.files[0];
//                         if (file) {
//                           if (file.type.startsWith("image/")) {
//                             const imageUrl = URL.createObjectURL(file);
//                             setAadharImgPreview(imageUrl);
//                             setDocumentName(file.name); // Set the file name, not the file object
//                             setSelectedDocumentFile(file); // Keep the file for uploading
//                           } else {
//                             toast.error("Please upload a valid image file.");
//                           }
//                         }
//                       }}
//                     />
//                     <div>
//                       <img
//                         src={aadharImgPreview}
//                         style={{ width: "100px", height: "100px" }}
//                       />
//                       {console.log(aadharImgPreview)}
//                     </div>
//                   </div>
//                 </div>
//                 {/* row 5 */}
//                 {/* <div className="btnAdminContainer">
//               <span className="textUpdate">{translations[language].update}</span>
//               <button className="btnAdmin">
//                 <span className="me-1 fs-5">
//                   <CgProfile />
//                 </span>
//                 Admin
//               </button>
//             </div> */}
//               </div>
//             ) : (
//               <div className="detailsContainer">
//                 <div className="detailsGrid">
//                   <div>
//                     <div>
//                       <label>{translations[language].about}</label>
//                     </div>
//                     <textarea
//                       rows={4}
//                       placeholder="Type here"
//                       onChange={formik.handleChange}
//                       name="about"
//                       value={formik.values.about}
//                     />
//                   </div>
//                 </div>
//                 <div className="detailsGrid">
//                   <div>
//                     <div>
//                       <label>{translations[language].terms}</label>
//                     </div>
//                     <textarea
//                       placeholder="Type here"
//                       onChange={formik.handleChange}
//                       rows={4}
//                       name="terms_condition"
//                       value={formik.values.terms_condition}
//                     />
//                   </div>
//                 </div>
//               </div>
//             )}

//             <div className="btnSaveContainer">
//               <button type="submit">{translations[language].btnSave}</button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// }

import React, { useContext, useEffect, useState } from "react";
import "./MatchmakerProfileEdit.css";
import profileImg from "../../assets/images/placeholder-image.jpg";
import cameraImg from "../../assets/images/camera.png";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import { axiosInstance } from "../../axiosInstance";
import translations from "./translation.json";
import { LanguageContext } from "../../Components/LanguageContext";
import Select from "react-select";
import * as Yup from "yup";
import Preloader from "../../Components/Loader/Loader";
import { BsArrowLeft } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import { IoIosClose } from "react-icons/io";
import Modal from "@mui/material/Modal";

const options = [
  { value: "Match Maker", label: "Match Maker" },
  { value: "Photographer", label: "Photographer", isDisabled: true },
  { value: "Beautician", label: "Beautician", isDisabled: true },
  {
    value: "Event Hall Manager",
    label: "Event Hall Manager",
    isDisabled: true,
  },
];
const bankOptions = [
  { value: "Union Bank of India", label: "Union Bank of India" },
  { value: "UCO Bank", label: "UCO Bank" },
  { value: "State Bank of India", label: "State Bank of India" },
  { value: "Punjab National Bank", label: "Punjab National Bank" },
  { value: "Canara Bank", label: "Canara Bank" },
  { value: "Bank of Maharashtra", label: "Bank of Maharashtra" },
];

const SUPPORTED_FORMATS = [
  "image/jpeg",
  "image/png",
  "image/jpg",
  "image/webp",
];
const ValidateSchema = Yup.object().shape({
  // profile_pic: Yup.mixed()
  //   .nullable()  // allow empty (not required)
  //   .test(
  //     "fileFormat",
  //     "Only PNG, JPG, JPEG, or WEBP images are allowed",
  //     (value) => {
  //       if (!value) return true; // allow empty (not required)
  //       return SUPPORTED_FORMATS.includes(value.type); // check type if file exists
  //     }
  //   ),
  //   ifsc_code: Yup.string()
  //     .nullable()
  //   .notRequired()
  // .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code formate ex.SBIN0000123 "), //SBIN0000123 SBIN000012A
  //  ifsc_code: Yup.string()
  //   .nullable()
  //   .notRequired()
  //   .test(
  //     "is-valid-ifsc",
  //     "Invalid IFSC code format (e.g., SBIN0000123)",
  //     function (value) {
  //       if (!value || value.trim() === "") return true; // Allow empty/null
  //       return /^[A-Z]{4}0[A-Z0-9]{6}$/.test(value);    // Validate only if not empty
  //     }
  //   ),
  first_name: Yup.string().matches(/^[A-Za-z]+$/, "Only alphabets are allowed"),
  last_name: Yup.string().matches(/^[A-Za-z]+$/, "Only alphabets are allowed"),
  email: Yup.string().email("Invalid email format"),
  account_number: Yup.string()
    .nullable()
    .notRequired()
    .matches(/^\d+$/, "Bank account number must contain only numbers"),
});
export function MatchmakerProfileEdit() {
  const location = useLocation();
  const activeBankDetails = location.state?.activeBankDetails; // getting from home.js redeem
  console.log("activeMenu",activeBankDetails);
  const { language } = useContext(LanguageContext);

  const [profileImgPreview, setProfileImgPreview] = useState(profileImg);
  const [selectedProfileFile, setSelectedProfileFile] = useState(null);
  const [documentname, setDocumentName] = useState("Browse");
  const [selectedDocumentFile, setSelectedDocumentFile] = useState(null);
  const [aadharImgPreview, setAadharImgPreview] = useState(null);
  const [activeTab, setActiveTab] = useState(activeBankDetails || "basicdetails");
  const [loading, setLoading] = useState(false);
  const [isFocusedAccountNumber, setIsFocusedAccountNumber] = useState(false);
  const [userPlan, setUserPlan] = useState(""); // User's current plan name
  const [plans, setPlans] = useState([]);
  const [open, setOpen] = useState(false);
  const [promoCodeInput, setPromoCodeInput] = useState("");
  const [promoTouched, setPromoTouched] = useState(false);
  const [promocodeError, setPromocodeError] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("Premium");
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      profile_pic: "",
      mobile: "",
      email: "",
      category: [],
      full_name: "",
      first_name: "",
      last_name: "",
      agency_name: "",
      document: "",
      about: "",
      terms_condition: "",
      account_number: "",
      ifsc_code: "" || null,
      bank: "",
    },
    validationSchema: ValidateSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const formData = new FormData();
        const bank_number = Number(values.account_number);
        formData.append("first_name", values.first_name);
        formData.append("last_name", values.last_name);
        formData.append("email", values.email);
        formData.append("mobile", values.mobile);
        formData.append("agency_name", values.agency_name);
        formData.append("document", values.document);
        formData.append("about", values.about);
        formData.append("terms_condition", values.terms_condition);
        formData.append("category", values.category);
        formData.append("account_number", bank_number);
        formData.append("ifsc_code", values.ifsc_code);
        formData.append("bank", values.bank);

        if (selectedProfileFile)
          formData.append("profile_pic", selectedProfileFile);
        if (selectedDocumentFile)
          formData.append("document", selectedDocumentFile);
      

        const response = await axiosInstance.put("profile", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.data.status === true) {
          setLoading(false);
          toast.success("Updated Successfully!");
          LoadProfile();
        } else {
          toast.error("Something went wrong, please try again!");
        }
      } catch (error) {
        console.error("Submission failed:", error);
        toast.error("Submission failed! Please try again.");
      }
    },
  });

  async function LoadProfile() {
    try {
      const response = await axiosInstance.get("profile");
      const { data } = response.data;
      if (data) {
        const {
          profile_pic = "",
          mobile = "",
          first_name = "",
          last_name = "",
          email = "",
          category = [],
          agency_name = "",
          document = "",
          about = "",
          terms_condition = "",
          account_number = "",
          ifsc_code = "",
          bank = "",
        } = data;

        formik.setValues({
          profile_pic,
          mobile,
          first_name,
          last_name,
          email,
          category: category[0] || "",
          agency_name,
          document,
          about,
          terms_condition,
          account_number,
          ifsc_code,
          bank,
        });

        setProfileImgPreview(profile_pic || profileImg);
        setAadharImgPreview(document || null);
        setDocumentName(document ? "Uploaded" : "Browse");
      }
    } catch (error) {
      console.error("Error fetching user details", error);
    }
  }

  useEffect(() => {
    LoadProfile();
  }, []);

  const getMaskedAccountNumber = (number) => {
    if (!number || number.length < 4) return "XXXXXXXXXXX";
    return (
      number.toString().slice(0, -3).replace(/./g, "X") +
      number.toString().slice(-3)
    );
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "90%",
      sm: 400,
      md: 500,
    },
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "10px",
    py: 4,
    px: 2,
  };

  const handleOpen = (plan) => {
    setSelectedPlan(plan);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setPromocodeError("");
  };

  useEffect(() => {
    LoadMatchmaker();
    LoadPlans();
  }, []);

  async function LoadMatchmaker() {
    try {
      const response = await axiosInstance.get("profile");
      const matchmakerData = response.data.data;
      setUserPlan(matchmakerData.plan); // e.g. "Basic", "Recommended", "Premium"
    } catch (error) {
      console.error("Error fetching user profile", error);
    }
  }

  async function LoadPlans() {
    try {
      const response = await axiosInstance.get("plans");
      const planData = response.data.data;
      setPlans(planData);
    } catch (error) {
      console.error("Error fetching plans", error);
    }
  }

  const premiumPlan = plans.find((plan) => plan.plan_name === "Premium");

  // Conditionally render based on userPlan
  const shouldShowSection =
    userPlan === "Recommended" || userPlan === "Premium";
  const shouldShowPremiumCard = userPlan === "Recommended";
  const shouldShowContactUsCard =
    userPlan === "Recommended" || userPlan === "Premium";

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  async function handlePayment() {
    try {
      const storedPromoCode = localStorage.getItem("appliedPromoCode") || "";

      const response = await axiosInstance.post("razorpay/create-order", {
        plan_type: selectedPlan,
        promo_code: storedPromoCode,
      });

      const { order_id, key_id, amount, currency } = response.data;

      const options = {
        key: key_id,
        amount: parseInt(amount, 10),
        currency,
        order_id,
        handler: async function (response) {
          try {
            const verifyResponse = await axiosInstance.post(
              "razorpay/verify-payment",
              {
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
                promo_code: storedPromoCode,
              }
            );

            if (verifyResponse.data.status === "success") {
              navigate("/payment-success");
              localStorage.removeItem("appliedPromoCode");
            }
          } catch (error) {
            console.error("Payment verification failed", error);
            navigate("/payment-failed");
          }
        },
        prefill: {
          name: localStorage.getItem("matchmaker_fullname"),
          email: localStorage.getItem("matchmaker_email"),
          contact: localStorage.getItem("phoneNumber"),
        },
        theme: {
          color: "#3399cc",
        },
        modal: {
          ondismiss: function () {
            toast.warning("Payment was canceled! Please try again.");
            navigate("/home");
          },
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.log("Payment Error", error);
    }
  }

  return (
    <>
      {loading && <Preloader />}
      <ToastContainer />
      <div className="matchmakerEditBg">
        <div className="container">
          <div className="profileImgContainer">
            <Link to="/home" className="textBack">
              <div className="textBack">
                <BsArrowLeft className="me-1" />
                Back
              </div>
            </Link>
            <div className="matchmakerProfileImg">
              <img src={profileImgPreview} alt="Profile" />
            </div>
            <div className="cameraImgContainer">
              <label htmlFor="cameraImg">
                <img src={cameraImg} />
              </label>
              <input
                type="file"
                id="cameraImg"
                accept="image/*"
                style={{ display: "none" }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const imageUrl = URL.createObjectURL(file);
                    setProfileImgPreview(imageUrl);
                    setSelectedProfileFile(file);
                  }
                }}
              />
              <div>
                {formik.touched.profile_pic && formik.errors.profile_pic && (
                  <div className="text-danger text-center">
                    {formik.errors.profile_pic}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="profile-tabs">
            <button
              onClick={() => setActiveTab("basicdetails")}
              className={
                activeTab === "basicdetails" ? "active-profiletab" : ""
              }
            >
              {translations[language].basic_details}
            </button>
            <button
              onClick={() => setActiveTab("moredetails")}
              className={activeTab === "moredetails" ? "active-profiletab" : ""}
            >
              {translations[language].more_details}
            </button>
            <button
              onClick={() => setActiveTab("bankdetails")}
              className={activeTab === "bankdetails" ? "active-profiletab" : ""}
            >
              {translations[language].bank_details}
            </button>
            {userPlan !== "Basic" && (
              <button
                onClick={() => setActiveTab("upgradeplan")}
                className={
                  activeTab === "upgradeplan" ? "active-profiletab" : ""
                }
              >
                {translations[language].upgrade_Plan}
              </button>
            )}
          </div>

          <form onSubmit={formik.handleSubmit}>
            {activeTab === "basicdetails" && (
              <div className="detailsContainer">
                <div className="detailsGrid">
                  <div>
                    <label htmlFor="first_name">
                      {translations[language].first_name}
                    </label>
                    <input
                      type="text"
                      onChange={formik.handleChange}
                      value={
                        formik.values.first_name === null ||
                        formik.values.first_name === "null" ||
                        formik.values.first_name === undefined
                          ? ""
                          : formik.values.first_name
                      }
                      id="first_name"
                    />
                    {formik.touched.first_name && formik.errors.first_name && (
                      <div className="text-danger text-center">
                        {formik.errors.first_name}
                      </div>
                    )}
                  </div>
                  <div>
                    <label htmlFor="last_name">
                      {translations[language].last_name}
                    </label>
                    <input
                      type="text"
                      onChange={formik.handleChange}
                      value={
                        formik.values.last_name === null ||
                        formik.values.last_name === "null" ||
                        formik.values.last_name === undefined
                          ? ""
                          : formik.values.last_name
                      }
                      id="last_name"
                    />
                    {formik.touched.last_name && formik.errors.last_name && (
                      <div className="text-danger text-center">
                        {formik.errors.last_name}
                      </div>
                    )}
                  </div>
                </div>

                <div className="detailsGrid">
                  <div>
                    <label htmlFor="email">
                      {translations[language].email}
                    </label>
                    <input
                      type="email"
                      onChange={formik.handleChange}
                      value={
                        formik.values.email === null ||
                        formik.values.email === "null" ||
                        formik.values.email === undefined
                          ? ""
                          : formik.values.email
                      }
                      id="email"
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="text-danger text-center">
                        {formik.errors.email}
                      </div>
                    )}
                  </div>
                  <div>
                    <label htmlFor="mobile">
                      {translations[language].mobile}
                    </label>
                    <input
                      type="text"
                      onChange={formik.handleChange}
                      id="mobile"
                      value={
                        formik.values.mobile === null ||
                        formik.values.mobile === "null" ||
                        formik.values.mobile === undefined
                          ? ""
                          : formik.values.mobile
                      }
                      disabled
                    />
                  </div>
                </div>

                <div className="detailsGrid">
                  <div>
                    <label>{translations[language].profession}</label>
                    <Select
                      placeholder="Select"
                      options={options}
                      isSearchable={false}
                      value={options.find(
                        (option) => option.value === formik.values.category
                      )} //for formik
                      onChange={(selectedOption) =>
                        formik.setFieldValue("category", selectedOption.value)
                      } //for formik
                      // styles={{
                      //   control: (base, state) => ({
                      //     ...base,
                      //     width: "100%",
                      //     minHeight: "40px",
                      //     height: "40px",
                      //     fontSize: "16px",
                      //     display: "flex",
                      //     alignItems: "center",
                      //     borderColor: "#e4e4e4",
                      //     backgroundColor: "#ffffff",
                      //     borderRadius: "10px",
                      //     // marginBottom: "10px",
                      //     borderColor: state.isFocused
                      //       ? "#e4e4e4"
                      //       : base.borderColor,
                      //     boxShadow: state.isFocused
                      //       ? "#e4e4e4"
                      //       : base.boxShadow,
                      //     "&:hover": {
                      //       borderColor: "#e4e4e4",
                      //     },

                      //   }),
                      //   indicatorSeparator: () => ({
                      //     display: "none",
                      //   }),
                      //   option: (base, state) => ({
                      //     ...base,
                      //     backgroundColor: state.isFocused
                      //       ? "#FEECF0"
                      //       : state.isSelected
                      //       ? "transparent"
                      //       : "transparent",
                      //     color: "#707070",
                      //     cursor: "pointer",
                      //     ":active": {
                      //       backgroundColor: "#FEECF0", // fixes the blue flicker when selecting
                      //     },
                      //   }),

                      //   menu: (base) => ({
                      //     ...base,
                      //     width: "100%",
                      //   }),
                      //   singleValue: (base) => ({
                      //     ...base,
                      //     whiteSpace: "nowrap",
                      //     overflow: "hidden",
                      //     textOverflow: "ellipsis",
                      //   }),
                      // }}

                      styles={{
                        control: (base, state) => ({
                          ...base,
                          width: "100%",
                          minHeight: "40px",
                          height: "40px",
                          fontSize: "16px",
                          display: "flex",
                          alignItems: "center", // vertically centers the content
                          padding: "-4px 8px", // remove paddingBottom

                          borderColor: "#e4e4e4",
                          backgroundColor: "#ffffff",
                          borderRadius: "10px",
                          borderColor: state.isFocused
                            ? "#e4e4e4"
                            : base.borderColor,
                          boxShadow: state.isFocused
                            ? "#e4e4e4"
                            : base.boxShadow,
                          "&:hover": {
                            borderColor: "#e4e4e4",
                          },
                        }),
                        indicatorSeparator: () => ({
                          display: "none",
                        }),
                        option: (base, state) => ({
                          ...base,
                          backgroundColor: state.isFocused
                            ? "#FEECF0"
                            : state.isSelected
                            ? "transparent"
                            : "transparent",
                          color: "#707070",
                          cursor: "pointer",
                          ":active": {
                            backgroundColor: "#FEECF0",
                          },
                        }),
                        menu: (base) => ({
                          ...base,
                          width: "100%",
                        }),
                        placeholder: (base, state) => ({
                          ...base,
                          position: "absolute",
                          top: "5px", // move placeholder above
                          left: "8px",
                          fontSize: "16px", // smaller font for floating effect
                          color: "#999999",
                          backgroundColor: "#ffffff",
                          padding: "0 4px",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          marginTop: "-20px", // shift text slightly up
                          lineHeight: "20px",
                        }),
                      }}
                    />
                  </div>
                  <div>
                    <label htmlFor="agency_name">
                      {translations[language].agency_name}
                    </label>
                    <input
                      type="text"
                      onChange={formik.handleChange}
                      value={
                        formik.values.agency_name === null ||
                        formik.values.agency_name === "null" ||
                        formik.values.agency_name === undefined
                          ? ""
                          : formik.values.agency_name
                      }
                      id="agency_name"
                    />
                  </div>
                </div>

                <div className="detailsGrid">
                  <div>
                    <label>{translations[language].aadhaar_pan}</label>
                    <label htmlFor="document" className="custom-file-labelEdit">
                      {documentname}
                    </label>
                    <input
                      type="file"
                      id="document"
                      className="custom-file-input"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file?.type.startsWith("image/")) {
                          setAadharImgPreview(URL.createObjectURL(file));
                          setDocumentName(file.name);
                          setSelectedDocumentFile(file);
                        } else {
                          toast.error("Please upload a valid image file.");
                        }
                      }}
                    />
                    {aadharImgPreview && (
                      <img
                        src={aadharImgPreview}
                        style={{ width: "100px", height: "100px" }}
                        alt="Document Preview"
                      />
                    )}
                  </div>
                </div>
              </div>
            )}

            {activeTab === "moredetails" && (
              <div className="detailsContainer">
                <div className="detailsGrid">
                  <div>
                    <label>{translations[language].about}</label>
                    <textarea
                      rows={4}
                      onChange={formik.handleChange}
                      name="about"
                      value={
                        formik.values.about === null ||
                        formik.values.about === "null" ||
                        formik.values.about === undefined
                          ? ""
                          : formik.values.about
                      }
                      placeholder={
                        !formik.values.about ||
                        formik.values.about === "null" ||
                        formik.values.about === null
                          ? "Hi, I’m Nathicharami, a trusted matchmaker from AP with 20+ years of experience and 1000+ happy matches."
                          : ""
                      }
                    />
                  </div>
                </div>
                <div className="detailsGrid">
                  <div>
                    <label>{translations[language].terms}</label>
                    <textarea
                      rows={8}
                      onChange={formik.handleChange}
                      name="terms_condition"
                      value={
                        formik.values.terms_condition === null ||
                        formik.values.terms_condition === "null" ||
                        formik.values.terms_condition === undefined
                          ? ""
                          : formik.values.terms_condition
                      }
                      placeholder={
                        !formik.values.terms_condition ||
                        formik.values.terms_condition === "null" ||
                        formik.values.terms_condition === null
                          ? "Our institute charges a registration fee of ₹XXX and a success fee upon confirmed match settlement. Fees are non-refundable. We ensure verified profiles, but final decisions rest with families. Services are valid for 1 year from the date of registration. We maintain confidentiality and do not guarantee matches. Misuse of platform details will lead to cancellation without refund."
                          : ""
                      }
                    />
                  </div>
                </div>
              </div>
            )}

            {activeTab === "bankdetails" && (
              <div className="detailsContainer">
                <div className="detailsGrid">
                  <div>
                    <label>{translations[language].bankAccount}</label>
                    <input
                      type="text"
                      name="account_number"
                      // value={
                      //   formik.values.account_number === null ||
                      //   formik.values.account_number === 0 ||
                      //   formik.values.account_number === "0" ||
                      //   formik.values.account_number === "null" ||
                      //   formik.values.account_number === undefined
                      //     ? ""
                      //     : getMaskedAccountNumber(formik.values.account_number)
                      // }
                      value={
                        isFocusedAccountNumber
                          ? formik.values.account_number || "" // show real value while typing
                          : formik.values.account_number
                          ? getMaskedAccountNumber(formik.values.account_number) // masked when blurred
                          : ""
                      }
                      onFocus={() => setIsFocusedAccountNumber(true)}
                      onChange={formik.handleChange}
                      onBlur={(e) => {
                        setIsFocusedAccountNumber(false);
                        formik.handleBlur(e); // also trigger Formik's blur
                      }}
                    />
                    {formik.touched.account_number &&
                      formik.errors.account_number && (
                        <div className="text-danger text-center">
                          {formik.errors.account_number}
                        </div>
                      )}
                  </div>
                  <div>
                    <label>{translations[language].ifsc}</label>
                    <input
                      type="text"
                      name="ifsc_code"
                      value={
                        formik.values.ifsc_code === null ||
                        formik.values.ifsc_code === "0" ||
                        formik.values.ifsc_code === 0 ||
                        formik.values.ifsc_code === "null" ||
                        formik.values.ifsc_code === undefined
                          ? ""
                          : formik.values.ifsc_code
                      }
                      onChange={formik.handleChange}
                    />
                    <div>
                      {formik.touched.ifsc_code && formik.errors.ifsc_code && (
                        <div className="text-danger text-center">
                          {formik.errors.ifsc_code}
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    <label>{translations[language].bankName}</label>
                    {/* <Select
                      placeholder="Select"
                      options={bankOptions}
                      isSearchable={false}
                      value={options.find(
                        (option) => option.value === formik.values.bank
                      )} //for formik
                      onChange={(selectedOption) =>
                        formik.setFieldValue("bank", selectedOption.value)
                      } //for formik
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          width: "100%",
                          minHeight: "40px",
                          height: "40px",
                          fontSize: "16px",
                          display: "flex",
                          alignItems: "center",
                          borderColor: "#e4e4e4",
                          backgroundColor: "#ffffff",
                          borderRadius: "10px",
                          // marginBottom: "10px",
                          borderColor: state.isFocused
                            ? "#e4e4e4"
                            : base.borderColor,
                          boxShadow: state.isFocused
                            ? "#e4e4e4"
                            : base.boxShadow,
                          "&:hover": {
                            borderColor: "#e4e4e4",
                          },
                        }),
                        indicatorSeparator: () => ({
                          display: "none",
                        }),
                        option: (base, state) => ({
                          ...base,
                          backgroundColor: state.isFocused
                            ? "#FEECF0"
                            : state.isSelected
                            ? "transparent"
                            : "transparent",
                          color: "#707070",
                          cursor: "pointer",
                          ":active": {
                            backgroundColor: "#FEECF0", // fixes the blue flicker when selecting
                          },
                        }),

                        menu: (base) => ({
                          ...base,
                          width: "100%",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }),
                      }}
                    /> */}
                    <Select
                      placeholder="Select"
                      options={bankOptions}
                      isSearchable={false}
                      value={bankOptions.find(
                        (option) => option.value === formik.values.bank
                      )}
                      onChange={(selectedOption) =>
                        formik.setFieldValue("bank", selectedOption.value)
                      }
                      // styles={{
                      //   control: (base, state) => ({
                      //     ...base,
                      //     width: "100%",
                      //     minHeight: "40px",
                      //     height: "40px",
                      //     fontSize: "16px",
                      //     display: "flex",
                      //     alignItems: "center",
                      //     borderColor: "#e4e4e4",
                      //     backgroundColor: "#ffffff",
                      //     borderRadius: "10px",
                      //     borderColor: state.isFocused
                      //       ? "#e4e4e4"
                      //       : base.borderColor,
                      //     boxShadow: state.isFocused
                      //       ? "#e4e4e4"
                      //       : base.boxShadow,
                      //     "&:hover": {
                      //       borderColor: "#e4e4e4",
                      //     },
                      //   }),
                      //   indicatorSeparator: () => ({
                      //     display: "none",
                      //   }),
                      //   option: (base, state) => ({
                      //     ...base,
                      //     backgroundColor: state.isFocused
                      //       ? "#FEECF0"
                      //       : state.isSelected
                      //       ? "transparent"
                      //       : "transparent",
                      //     color: "#707070",
                      //     cursor: "pointer",
                      //     ":active": {
                      //       backgroundColor: "#FEECF0",
                      //     },
                      //   }),
                      //   menu: (base) => ({
                      //     ...base,
                      //     width: "100%",
                      //   }),
                      //   singleValue: (base) => ({
                      //     ...base,
                      //     whiteSpace: "nowrap",
                      //     overflow: "hidden",
                      //     textOverflow: "ellipsis",
                      //   }),
                      // }}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          width: "100%",
                          minHeight: "40px",
                          height: "40px",
                          fontSize: "16px",
                          display: "flex",
                          alignItems: "center", // vertically centers the content
                          padding: "-4px 8px", // remove paddingBottom

                          borderColor: "#e4e4e4",
                          backgroundColor: "#ffffff",
                          borderRadius: "10px",
                          borderColor: state.isFocused
                            ? "#e4e4e4"
                            : base.borderColor,
                          boxShadow: state.isFocused
                            ? "#e4e4e4"
                            : base.boxShadow,
                          "&:hover": {
                            borderColor: "#e4e4e4",
                          },
                        }),
                        indicatorSeparator: () => ({
                          display: "none",
                        }),
                        option: (base, state) => ({
                          ...base,
                          backgroundColor: state.isFocused
                            ? "#FEECF0"
                            : state.isSelected
                            ? "transparent"
                            : "transparent",
                          color: "#707070",
                          cursor: "pointer",
                          ":active": {
                            backgroundColor: "#FEECF0",
                          },
                        }),
                        menu: (base) => ({
                          ...base,
                          width: "100%",
                        }),
                        placeholder: (base, state) => ({
                          ...base,
                          position: "absolute",
                          top: "5px", // move placeholder above
                          left: "8px",
                          fontSize: "16px", // smaller font for floating effect
                          color: "#999999",
                          backgroundColor: "#ffffff",
                          padding: "0 4px",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          marginTop: "-20px", // shift text slightly up
                          lineHeight: "20px",
                        }),
                      }}
                    />
                  </div>
                </div>
              </div>
            )}

            {activeTab === "upgradeplan" && userPlan !== "Basic" && (
              <div className="detailsContainer">
                <div className="detailsGrid">
                  <div
                    className={`upgradePlan-container ${
                      userPlan === "Premium" ||
                      (userPlan === "Recommended" && !shouldShowPremiumCard)
                        ? "single-card-layout"
                        : ""
                    }`}
                  >
                    {/* First Card */}
                    {/* Show Recommended card only if user is on Recommended plan */}
                    {shouldShowPremiumCard && premiumPlan && (
                      <div className="upgradePlanCard">
                        <div className="upgradePlan-info-center">
                          <div className="upgradePlan-active-type">
                            {premiumPlan.plan_name}
                          </div>
                          <div className="upgradePlan-active-cost">
                            ₹ {premiumPlan.plan_price}
                            <span style={{ fontSize: "18px" }}>
                              /{premiumPlan.plan_validity} months
                            </span>
                          </div>
                          <div className="upgradePlan-offer-price-standard">
                            <strike>
                              <p className="strike-price-premium">
                                ₹{plans[2].strike_price}
                              </p>
                            </strike>
                            <p className="per-day-price-standard">
                              50% Off • ₹18/day
                            </p>
                          </div>
                          <div className="upgradePlan-active-data">
                            <div>{translations[language].card3_plan_data1}</div>
                            <div>{translations[language].card3_plan_data2}</div>
                          </div>
                        </div>

                        <ul className="upgradePlanCardActiveList">
                          <li>{translations[language].card3_li1}</li>
                          <li>{translations[language].card3_li2}</li>
                          <li>{translations[language].card3_li3}</li>
                          <li>{translations[language].card3_li4}</li>
                          <li>{translations[language].card3_li5}</li>
                          <li>{translations[language].card3_li6}</li>
                          <li>{translations[language].card3_li7}</li>
                          <li>{translations[language].card3_li8}</li>
                          {/* <li>{translations[language].card3_li9}</li> */}
                        </ul>

                        <div
                          className="upgradePlan-btnActive"
                          onClick={() => {
                            setSelectedPlan("Premium"); // or the actual plan ID/type needed
                            setOpen(true); // open promocode modal
                          }}
                        >
                          Choose Plan
                        </div>
                      </div>
                    )}

                    {/* Second Card */}
                    {shouldShowContactUsCard && (
                      <div className="upgradePlanCard customCard">
                        <div className="customCardContent">
                          <div className="upgradePlan-info-center">
                            <div className="CreateYourCustom-active-type">
                              Create your Custom Profile
                            </div>
                            <div className="upgradePlan-active-data">
                              <div>
                                {translations[language].card4_plan_data1}
                              </div>
                            </div>
                          </div>

                          <ul className="CreateYourCustomActiveList">
                            <li>{translations[language].card4_li1}</li>
                            <li>{translations[language].card4_li2}</li>
                            <li>{translations[language].card4_li3}</li>
                            <li>{translations[language].card4_li4}</li>
                            <li>{translations[language].card4_li5}</li>
                            <li>{translations[language].card4_li6}</li>
                          </ul>

                          <div
                            className="CreateYourCustom-btnActive"
                            onClick={() => {
                              navigate("/contact-us");
                            }}
                          >
                            Contact Us
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {activeTab !== "upgradeplan" && (
              <div className="btnSaveContainer">
                <button type="submit">{translations[language].btnSave}</button>
              </div>
            )}
          </form>
        </div>
      </div>

      {/* promocode modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            className="fs-4 "
            style={{
              position: "absolute",
              top: 2,
              right: 8,

              cursor: "pointer",
              zIndex: 1,
            }}
            onClick={handleClose}
          >
            <IoIosClose size={28} />
          </div>

          <form
            onSubmit={async (e) => {
              e.preventDefault();
              setPromoTouched(true);
              if (!promoCodeInput.trim()) {
                setPromocodeError("Enter Promocode");
                return;
              }
              try {
                const res = await axiosInstance.post("promo-code", {
                  promo_code: promoCodeInput.trim(),
                });
                if (res.data.status) {
                  toast.success("Promocode Applied");
                  localStorage.setItem(
                    "appliedPromoCode",
                    promoCodeInput.trim()
                  );
                  setPromocodeError("");
                  handleClose();
                  handlePayment();
                } else {
                  setPromocodeError("Invalid Promocode");
                }
              } catch (error) {
                const msg =
                  error.response?.data?.message || "Submission Failed";
                toast.error(msg);
                setPromocodeError(msg);
              }
            }}
          >
            <div className="d-flex justify-content-between mb-3">
              <div className="promocode-text">Enter Your Promocode</div>
              <div
                className="text-skip"
                onClick={() => {
                  handleClose();
                  handlePayment(); // <-- This opens Razorpay modal
                }}
              >
                Skip
              </div>
            </div>

            <div className="promocodeInput">
              <input
                type="text"
                placeholder="Promocode"
                value={promoCodeInput}
                onChange={(e) => setPromoCodeInput(e.target.value)}
                onBlur={() => setPromoTouched(true)}
              />
              {promoTouched && !promoCodeInput.trim() && (
                <div className="text-danger">Enter Promocode</div>
              )}
            </div>

            {promocodeError && (
              <div className="text-danger mt-2 mb-2">{promocodeError}</div>
            )}

            <div className="btnPromoSubmit mt-3">
              <button type="submit">Submit</button>
            </div>
          </form>
        </Box>
      </Modal>
    </>
  );
}
